import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  isAlertOpen: any = false;

  constructor(private toastController: ToastController, private alertController: AlertController,private translate: TranslateService) { }

  async toastMsg(
    message: string,
    duration: number = 3000,
    color: 'success' | 'danger' | 'warning' | 'medium' | 'dark' = 'medium'
  ) {
    const toast = await this.toastController.create({
      message,
      duration,
      color,
      position: 'bottom',
    });

    await toast.present();
  }

async showAlert(header: string, message: string): Promise<void> {
  const alert = await this.alertController.create({
    mode: 'md',
    header,
    message,
    backdropDismiss: false,
    buttons: [this.translate.instant('ok')],
  });

  await alert.present();
  await alert.onDidDismiss();
}
async showConfirm(
  header: string,
  message: string
): Promise<boolean> {

  // 🚫 prevent stacking
  if (this.isAlertOpen) return false;

  this.isAlertOpen = true;

  return new Promise(async (resolve) => {

    const alert = await this.alertController.create({
      mode: 'md',
      header,
      message,
      backdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertOpen = false;
            resolve(false);
          }
        },
        {
          text: this.translate.instant('yes'),
          handler: () => {
            this.isAlertOpen = false;
            resolve(true);
          }
        }
      ],
    });

    await alert.present();
  });
}

}
